/*
Poornima 09/19/2022 2698849438 Fixed GAL-127,132,73,60,104 bugs
saikrishna 10/03/2022 2698849438 jira Bugs _350,347,349
ashraf 10/04/2022 2698849438 fixed copy, page break issue
RajeshK 09/16/2022 2698849438 subscribed and unsubscribed services accordions
ashraf 09/22/2022 2698849438 fixed value validation in subscribe popup, add role button disabling
saikrishna 10/03/2022 2698849438 Feature: Added three fields in multiple places wherever required in client management
saikrishna 10/03/2022 2698849438 Fixed merge conflicts.
saikrishna 10/04/2022 2698849438 bugFix: fixexed bugs in column names
saikrishna 10/04/2022 2698849438 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
saikrishna 10/06/2022 2698849438 Removed unecesarry console.log statements
saikrishna 10/06/2022 2698849438 Fixed jira bugs in client maintenance.jira(417,18,384,263)
saikrishna 10/06/2022 2698849438 Fixed client maintenance bugs told by QA
saikrishna 10/07/2022 2698849438 Client maintenance bugs jira(428,29,30,417,418,384,261)
saikrishna 10/07/2022 2698849438 Fixed jira bugs role and client maintenance
ashraf 10/07/2022 2698849438 render table columns in popup with condition
ashraf 10/10/2022 2698849438 fixed tooltip for current rate popup in client maintenance, redirect when access is not given
ashraf 10/10/2022 2698849438 fixed role based access client maintenance edit rate popup issues
ashraf 10/10/2022 2698849438 fixed prepopulation issue in edit rate popup
Ravi 10/14/2022 2698849438 Client Maintenance ->Fixed GAL-487
*/

import React, {useContext, useEffect, useState} from 'react';
import {
  Grid,
  Button,
  FormHelperText,
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  InputAdornment,
  Radio,
  MenuItem,
  InputLabel,
  Select,
  Tooltip,
} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import * as Yup from 'yup';
import DateFnsUtils from '@date-io/date-fns';
import {Currency} from '../../../util/Currency';
import {ThemeContext} from '../../../themes/ThemeProvider';
import moment from 'moment';
import {Formik, Form} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {
  postSubscribeServiceData,
  resetMessage,
  resetStatus,
  saveRateCard,
} from '../../../redux/reducers/client-maintainance/ClientGeneral';
import PageLoader from '../../../components/PageLoader';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';

const rateTypeOptions = [
  {value: 'flat', key: 'Flat Fee'},
  {value: 'percentage', key: 'Percentage'},
];

const EditSubServiceTypeDialog = ({
  rowData,
  parentRowData,
  setEditSubServiceDialog,
  companyType,
  prePopData,
  futureEffeciveValidationArr,
}) => {
  const dispatch = useDispatch();
  const {subscribedService} = rowData;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // let initialValues;
  const {dateValidationData} = useSelector(({clientRateHistory}) => clientRateHistory);

  // if (!rowData.isCurrentRate) {
  const initialValues = {
    endDate: null,
    effectiveDate: null,
    rateType: '',
    value: '',
    serviceStatus: 'renew',
    rateNote: '',
    newEndDate: null,
    debtorOverPayments: 'none',
    inflationAgreement: 'none',
    postageAgreement: 'none',
  };
  // } else {
  //   initialValues = {
  //     endDate: null,
  //     // effectiveDate:
  //     //   null,
  //     rateType:
  //       prePopData && prePopData?.feeType
  //         ? prePopData?.feeType.includes("percen")
  //           ? {
  //             value: "percentage",
  //             key: "Percentage",
  //           }
  //           : {
  //             value: "flat",
  //             key: "Flat Fee",
  //           }
  //         : "",
  //     value: prePopData && prePopData?.feeValue ? prePopData?.feeValue : "",
  //     serviceStatus: "renew",
  //     // rateNote: prePopData && prePopData?.rateNotes ? prePopData?.rateNotes : "",
  //     debtorOverPayments: prePopData && prePopData?.paymentsRemitted ? prePopData?.paymentsRemitted : "none",
  //     inflationAgreement: prePopData && prePopData?.inflationAgreement ? prePopData?.inflationAgreement : "none",
  //     postageAgreement: prePopData && prePopData?.postageAgreement ? prePopData?.postageAgreement : "none",
  //     // newEndDate:
  //     //   prePopData && prePopData?.serviceEndDt ? new Date(prePopData?.serviceEndDt) : null,
  //   };

  // }
  const [serviceStatus, setServiceStatus] = useState('renew');
  const validationSchema = Yup.object().shape({
    rateNote: Yup.string().max(500, 'Note cannot exceed 500 characters'),
    debtorOverPayments: serviceStatus === 'renew' && Yup.string().test('null check', 'Debtor over payments remitted is required', function(fieldValue) {
      if (
        fieldValue === 'none'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    inflationAgreement: serviceStatus === 'renew' && Yup.string().test('null check', 'Inflation agreement is required', function(fieldValue) {
      if (
        fieldValue === 'none'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    postageAgreement: serviceStatus === 'renew' && Yup.string().test('null check', 'Postage agreement is required', function(fieldValue) {
      if (
        fieldValue === 'none'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    rateType: subscribedService ?
      Yup.object()
        .nullable()
        .when('serviceStatus', {
          is: (val) => val === 'renew',
          then: Yup.object().nullable().required('Rate type is required'),
        }) :
      Yup.object().nullable().required('Rate type is required'),
    value: subscribedService ?
      Yup.string()
        .when('serviceStatus', {
          is: (val) => val === 'renew',
          then: Yup.string().required('Value is required'),
        })
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context.parent.rateType &&
              context.parent.rateType.value === 'percentage' &&
            Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        })
        .test('is Negative', 'Value can\'t be negative', function(fieldValue, context) {
          if (
            context.parent.rateType &&
            (context.parent.rateType.value === 'percentage' || context.parent.rateType.value === 'flat') &&
            Number(fieldValue) < 0
          ) {
            return false;
          } else {
            return true;
          }
        }) :
      Yup.string()
        .required('Value is required')
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context.parent.rateType &&
              context.parent.rateType.value === 'percentage' &&
            Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        })
        .test('is Negative', 'Value can\'t be negative', function(fieldValue, context) {
          if (
            context.parent.rateType &&
            (context.parent.rateType.value === 'percentage' || context.parent.rateType.value === 'flat') &&
            Number(fieldValue) < 0
          ) {
            return false;
          } else {
            return true;
          }
        }),
    effectiveDate: subscribedService ?
      null :
      Yup.date()
        .typeError('Invalid Date Format')
        .min(today, 'Start date should not be past date')
        .nullable()
        .required('Effective date is required'),
    endDate:
      Yup.date()
        .typeError('Invalid Date Format')
        .nullable()
        .test('length', 'End date should not be below the Old Effective Date', (date) => {
          // fixed effectiveDate validations
          const effectiveDate = moment(rowData.serviceStartDt).add(1, 'days').format('YYYY-MM-DD');
          const endDate = moment(date).format('YYYY-MM-DD');
          if (endDate >= effectiveDate) {
            return true;
          } else {
            return false;
          }
        })
        .required('End date is required'),
    newEndDate:
      Yup.date()
        .typeError('Invalid Date Format').nullable(),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {postRateCardStatus, isLoading, isSaveCardLoading, errorMsg} = useSelector(({clientGeneral}) => clientGeneral);

  useEffect(() => {
    if (postRateCardStatus && postRateCardStatus?.status === 200) {
      setEditSubServiceDialog(false);
    }
    setTimeout(() => {
      dispatch(resetMessage());
      dispatch(resetStatus());
    }, 3000);
  }, [postRateCardStatus]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
      }, 3000);
    }
  }, [errorMsg]);

  const onSubmit = (values) => {
    if (subscribedService) {
      const {clientNumber, feeType, feeValue, clientRatecardId} =
        rowData;
      const {rateType, value, endDate, effectiveDate, serviceStatus, rateNote, newEndDate} =
        values;
      const format = 'YYYY-MM-DD';
      const payload = {
        clientId: clientNumber || parentRowData.clientNumber,
        feeType: rateType && rateType.value.length > 0 ? rateType.value.toLowerCase() : feeType,
        feeValue: value && value.length > 0 ? value : feeValue,
        rateId: clientRatecardId,
        serviceEndDt: serviceStatus === 'renew' ? newEndDate && moment(newEndDate).format(format) : moment(endDate).format(format),
        serviceStartDt: effectiveDate ?
          moment(effectiveDate).format(format) :
          moment(getEffectiveDate(values)).format(format),
        terminated: serviceStatus === 'renew' ? '' : 'Y',
        rateNotes: rateNote,
        endDate: moment(endDate).format(format),
        // isCurrentRate
        //   ? moment(endDate).format(format)
        //   : newEndDate && moment(newEndDate).format(format),
        // isCurrentRate: true,
        subServiceType: rowData?.subServiceType,
        paymentsRemitted: values?.debtorOverPayments ? values?.debtorOverPayments : '',
        inflationAgreement: values?.inflationAgreement ? values?.inflationAgreement : '',
        postageAgreement: values?.inflationAgreement ? values?.inflationAgreement : '',
      };
      dispatch(saveRateCard(payload));
    } else {
      const payload = {
        clientCodeSuffix: rowData?.clientCodeSuffix ? rowData?.clientCodeSuffix : '',
        clientId: parentRowData?.clientId ? parentRowData?.clientId : '',
        clientName: parentRowData?.clientName ? parentRowData?.clientName : '',
        parentClientId: parentRowData?.parentClientId ? parentRowData?.parentClientId : '',
        serviceType: rowData?.serviceType ? rowData?.serviceType : '',
        subServiceType: rowData?.subServiceType ? rowData?.subServiceType : '',
        feeType: values.rateType.value,
        feeValue: values.value,
        rateNotes: values.rateNote,
        serviceStartDt: moment(values.effectiveDate).format('YYYY-MM-DD'),
        serviceEndDt: values.endDate && moment(values.endDate).format('YYYY-MM-DD'),
      };
      dispatch(postSubscribeServiceData(payload));
    }
  };

  const getEffectiveDate = (values) => {
    const {endDate} = values;
    if (endDate) {
      const date = new Date(values.endDate);
      date.setDate(date.getDate() + 1);
      return date;
    } else {
      return null;
    }
  };
  return (
    <div>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleReset,
            handleBlur,
            setTouched,
            touched,
            errors,
            resetForm,
          } = props;
          return (

            <Form noValidate autocomplete="off">
              <div className="col">
                <div className="rate-columns">
                  {subscribedService && (
                    <>
                      <div className="mb-3">
                        <div className="block-styling">
                          <div className="rate-headings">Current Rate: </div>
                          <div className="current-rate-table">
                            <div className="form-row">
                              <div className="col-md-6 d-flex flex-row justify-content-center align-items-center">
                                <div style={{width: '25%'}} className="font-weight-bold pl-3">Rate Type</div>
                                <div style={{width: '20%'}} className="font-weight-bold text-center">
                                  Value
                                </div>
                                <div style={{width: '27.5%'}} className="font-weight-bold">Start Date</div>
                                <div style={{width: '27.5%'}} className="font-weight-bold">End Date</div>
                              </div>
                              <div className="col-md-6 d-flex flex-row justify-content-center align-items-center">
                                <Tooltip title="Debtor Over Payments Remitted">
                                  <div className="font-weight-bold text-truncate" style={{width: '33.33%', overflow: 'hidden'}}>Debtor Over Payments Remitted</div>
                                </Tooltip>
                                <Tooltip title="Inflation Agreement">
                                  <div className="font-weight-bold text-truncate" style={{width: '33.33%', overflow: 'hidden'}}>Inflation Agreement</div>
                                </Tooltip>
                                <Tooltip title="Postage Agreement">
                                  <div className="font-weight-bold text-truncate" style={{width: '33.33%', overflow: 'hidden'}}>Postage Agreement</div>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                          <div className="current-rate-table-description">
                            <div className="form-row">
                              <div className="col-md-6 d-flex flex-row justify-content-center align-items-center">
                                <div style={{width: '25%'}} className=" pl-3">
                                  {rowData.feeType[0].toUpperCase() + rowData.feeType.slice(1) === 'Flat' ? 'Flat Fee' : 
                                    rowData.feeType[0].toUpperCase() + rowData.feeType.slice(1)}
                                </div>
                                <div style={{width: '20%'}} className="font-weight-bold text-center">
                                  {rowData?.feeType?.toLowerCase() === 'flat' ?
                                    '$' +
                                    rowData.feeValue.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    }) :
                                    rowData.feeValue.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    }) + '%'}
                                </div>
                                <div className="" style={{width: '27.5%'}}>
                                  {moment(rowData.serviceStartDt).format('MM/DD/YYYY')}
                                </div>
                                <div className="" style={{width: '27.5%'}}>
                                  {rowData?.serviceEndDt ?
                                    moment(rowData.serviceEndDt).format('MM/DD/YYYY') :
                                    ''}
                                </div>
                              </div>
                              <div className="col-md-6 d-flex flex-row justify-content-center align-items-center">
                                <div className="" style={{width: '33.33%'}}>
                                  {rowData && rowData?.paymentsRemitted ? rowData?.paymentsRemitted === 'send' ? 'Send' : 'Don\'t Send' : '-'}
                                </div>
                                <div className="" style={{width: '33.33%'}}>
                                  {rowData && rowData?.inflationAgreement ? rowData?.inflationAgreement : '-'}
                                </div>
                                <div className="" style={{width: '33.33%'}}>
                                  {rowData && rowData?.postageAgreement ? rowData?.postageAgreement : '-'}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="col-sm-6 mt-4 px-2 form-group">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Grid container>
                                  <KeyboardDatePicker
                                    className={` ${classes.labelName} ${classes.datePicker}`}
                                    format="MM/dd/yyyy"
                                    placeholder="MM/DD/YYYY"
                                    fullWidth
                                    value={values.endDate}
                                    name="endDate"
                                    minDate={new Date(moment(rowData.serviceStartDt).add(1, 'days').format('YYYY-MM-DD')) < new Date(moment(new Date()).format('YYYY-MM-DD')) 
                                      ? new Date(moment(new Date()).format('YYYY-MM-DD')) : new Date(moment(rowData?.serviceStartDt).add(1, 'days').format('YYYY-MM-DD'))}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    helperText={null}
                                    required
                                    onBlur={handleBlur}
                                    inputVariant="outlined"
                                    label="End Date"
                                    onChange={(val) => {
                                      setTouched({...touched, endDate: true});
                                      setFieldValue('endDate', val);
                                    }}
                                    autoOk
                                    margin="dense"
                                    touched={touched?.endDate}
                                    error={Boolean(touched?.endDate && errors?.endDate)}
                                  />
                                </Grid>
                              </MuiPickersUtilsProvider>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.endDate && errors && errors?.endDate}
                              </FormHelperText>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div>
                    {values.serviceStatus === 'renew' && (
                      <>
                        <div className="block-styling">
                          {subscribedService && <div className="rate-headings">New Rate: </div>}

                          <div className="form-row">
                            <div className="col-sm-6  form-group">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  options={rateTypeOptions}
                                  getOptionLabel={(option) => {
                                    return option && option.key && option.key;
                                  }}
                                  classes={{
                                    option: classes.option,
                                  }}
                                  size="small"
                                  autoHighlight
                                  name="rateType"
                                  value={values.rateType}
                                  onBlur={handleBlur}
                                  disabled={values.serviceStatus === 'terminate'}
                                  renderInput={(params) => (
                                    <GuiTextField
                                      className={` multiselect-label ${classes.labelName} ${classes.selectLabel} ${classes.multiselectlabel}`}
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                      required
                                      label={subscribedService ? 'Rate Type' : 'Rate Type'}
                                      name="rateType"
                                      touched={touched?.rateType}
                                      error={Boolean(touched?.rateType && errors?.rateType)}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      placeholder="Select Rate Type"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                    />
                                  )}
                                  onChange={(_, data) => {
                                    setFieldValue('rateType', data);
                                  }}
                                />
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.rateType && errors && errors?.rateType}
                              </FormHelperText>
                            </div>
                            <div className="col-sm-6 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                value={values[`value`]}
                                placeholder={`Enter Value`}
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                label={subscribedService ? 'Value' : 'Value'}
                                disabled={values.serviceStatus === 'terminate' || !values.rateType}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onBlur={handleBlur}
                                required
                                fullWidth
                                touched={touched?.value}
                                error={Boolean(touched?.value && errors?.value)}
                                name={`value`}
                                InputProps={
                                  values[`rateType`] && values[`rateType`].value === 'flat' ?
                                    {
                                      startAdornment: <InputAdornment>$</InputAdornment>,
                                      inputComponent: Currency,
                                    } :
                                    values[`rateType`] &&
                                      values[`rateType`].value === 'percentage' ?
                                      {
                                        endAdornment: <InputAdornment>%</InputAdornment>,
                                        inputComponent: Currency,
                                      } :
                                      {}
                                }
                                onChange={(e) => {
                                  setFieldValue(`value`, e.target.value);
                                }}
                              />
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.value && errors && errors?.value}
                              </FormHelperText>
                            </div>
                            {subscribedService && values.serviceStatus === 'renew' && (
                              <>
                                <div className="col-sm-6 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={
                                          values?.effectiveDate ?
                                            values.effectiveDate :
                                            errors.endDate && errors.endDate?.length > 0 ?
                                              null :
                                              getEffectiveDate(values)
                                        }
                                        minDate={new Date(moment(dateValidationData).add(1, 'days').format('YYYY-MM-DD'))}
                                        name="effectiveDate"
                                        minDateMessage={null}
                                        error={false}
                                        helperText={null}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        disabled={true}
                                        inputVariant="outlined"
                                        label="Start Date"
                                        onChange={(val) => {
                                          setFieldValue('effectiveDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-sm-6 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={values.newEndDate}
                                        minDate={getEffectiveDate(values)?.setDate(
                                          getEffectiveDate(values)?.getDate() + 1,
                                        )}
                                        minDateMessage={
                                          'End Date should be greater than Start Date'
                                        }
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        disabled={prePopData ? false : !getEffectiveDate(values)}
                                        inputVariant="outlined"
                                        label="End Date"
                                        onChange={(val) => {
                                          setFieldValue('newEndDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                </div>
                              </>
                            )}
                            {!subscribedService && (
                              <>
                                <div className="col-sm-6 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={values.effectiveDate}
                                        helperText={null}
                                        required
                                        name="effectiveDate"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        disabled={rowData.subscribedService}
                                        touched={touched?.effectiveDate}
                                        error={Boolean(
                                          touched?.effectiveDate && errors?.effectiveDate,
                                        )}
                                        inputVariant="outlined"
                                        label="Effective Date"
                                        onChange={(val) => {
                                          setTouched({...touched, effectiveDate: true});
                                          setFieldValue('effectiveDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                  <FormHelperText
                                    style={{color: 'red'}}
                                    margin="dense"
                                    variant="outlined"
                                  >
                                    {touched?.effectiveDate && errors && errors?.effectiveDate}
                                  </FormHelperText>
                                </div>
                                <div className="col-sm-6  form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={` ${classes.labelName} ${classes.datePicker}`}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        fullWidth
                                        value={values.endDate}
                                        disabled={!values?.effectiveDate}
                                        minDate={new Date()}
                                        minDateMessage={null}
                                        maxDateMessage={null}
                                        invalidDateMessage={'Invalid Date'}
                                        name="endDate"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        inputVariant="outlined"
                                        label="End Date"
                                        onChange={(val) => {
                                          setFieldValue('endDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                  <FormHelperText
                                    style={{color: 'red'}}
                                    margin="dense"
                                    variant="outlined"
                                  >
                                    {errors.endDate ? errors.endDate : ''}
                                  </FormHelperText>
                                </div>
                              </>
                            )}
                            <div className={`col-sm-6 form-group ${classes?.selectdropdown}`}>
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <InputLabel>Debtor Over Payments Remitted <span style={{color: touched?.debtorOverPayments && errors && errors?.debtorOverPayments ? 
                                  'red' : ''}}>*</span></InputLabel>
                                <Select
                                  fullWidth
                                  name="debtorOverPayments"
                                  className={classes.labelName}
                                  label="Debtor Over Payments Remitted"
                                  required
                                  autoHighlight
                                  value={
                                    values[`debtorOverPayments`]
                                  }
                                  onBlur={handleBlur}
                                  error={errors[`debtorOverPayments`] && touched[`debtorOverPayments`]}
                                  touched={touched && touched[`debtorOverPayments`]}
                                  onChange={(e) => {
                                    setFieldValue(`debtorOverPayments`, e.target.value);
                                  }}
                                >
                                  <MenuItem value="none" key="none">
                                    <span className="defaultSelected">Select Any</span>
                                  </MenuItem>
                                  <MenuItem value="send">Send</MenuItem>
                                  <MenuItem value="dont send">Don&apos;t Send</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.debtorOverPayments && errors && errors?.debtorOverPayments}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 form-group ${classes?.selectdropdown}`}>
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <InputLabel>Inflation Agreement <span style={{color: touched?.inflationAgreement && errors && errors?.inflationAgreement ? 
                                  'red' : ''}}>*</span></InputLabel>
                                <Select
                                  className={classes.labelName}
                                  fullWidth
                                  name={`inflationAgreement`}
                                  value={
                                    values[`inflationAgreement`]

                                  }
                                  onBlur={handleBlur}
                                  error={errors[`inflationAgreement`] && touched[`inflationAgreement`]}
                                  touched={touched && touched[`inflationAgreement`]}
                                  onChange={(e) => {
                                    setFieldValue(`inflationAgreement`, e.target.value);
                                  }}
                                >
                                  <MenuItem value="none" key="none" selected>
                                    <span className="defaultSelected">Select Any</span>
                                  </MenuItem>
                                  <MenuItem value="Has Agreement">Has Agreement</MenuItem>
                                  <MenuItem value="No Agreement">No Agreement</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.inflationAgreement && errors && errors?.inflationAgreement}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 form-group ${classes?.selectdropdown}`}>
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <InputLabel>Postage Agreement <span style={{color: touched?.postageAgreement && errors && errors?.postageAgreement ? 
                                  'red' : ''}}>*</span></InputLabel>
                                <Select
                                  fullWidth
                                  name={`postageAgreement`}
                                  value={
                                    values[`postageAgreement`]

                                  }
                                  onBlur={handleBlur}
                                  error={touched[`postageAgreement`] && errors[`postageAgreement`]}
                                  touched={touched && touched[`postageAgreement`]}
                                  onChange={(e) => {
                                    setFieldValue(`postageAgreement`, e.target.value);
                                  }}
                                >
                                  <MenuItem value="none" key="none">
                                    <span className="defaultSelected">Select Any</span>
                                  </MenuItem>
                                  <MenuItem value="Has Agreement">Has Agreement</MenuItem>
                                  <MenuItem value="No Agreement">No Agreement</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.postageAgreement && errors && errors?.postageAgreement}
                              </FormHelperText>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-sm-12 p-0 form-group">
                      <TextField
                        label={subscribedService ? 'Note' : 'Note'}
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={companyType === 'The WellFund, LLC'}
                        name="rateNote"
                        placeholder="Enter your note here"
                        multiline
                        fullWidth
                        error={!!errors?.rateNote}
                        maxRows={4}
                        value={values.rateNote}
                        onChange={(e) => {
                          setFieldValue('rateNote', e.target.value);
                        }}
                      />
                      <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                        {errors.rateNote ? errors.rateNote : ''}
                      </FormHelperText>
                    </div>
                  </div>
                </div>
              </div>
              {subscribedService && (
                <div className="col rate-columns">
                  <FormControl component="div" className={`${classes.radioGroup}`}>
                    <RadioGroup
                      aria-label="serviceStatus"
                      name="serviceStatus"
                      value={values.serviceStatus}
                      onChange={(e) => {
                        handleReset();
                        setServiceStatus(e.target.value);
                        setFieldValue('serviceStatus', e.target.value);
                      }}
                    >
                      <FormControlLabel
                        className={`${classes.checkRoot} ml-1`}
                        value="renew"
                        control={<Radio color="primary" />}
                        label="Update Rate"
                      />
                      <FormControlLabel
                        className={`${classes.checkRoot} ml-2`}
                        value="terminate"
                        control={<Radio color="primary" />}
                        label="Terminate"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              <div className="button-spacing-mb">
                <Button
                  type="reset"
                  onClick={() => {
                    resetForm(initialValues);
                    setEditSubServiceDialog(false);
                  }}
                  variant="contained"
                  className={`mx-1 ${classes.buttonRoot}`}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={!(values?.serviceStatus === 'terminate') ? (values?.newEndDate && values?.newEndDate < (getEffectiveDate(values)?.setDate(
                    getEffectiveDate(values)?.getDate()) + 1)) : false}
                  className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                  onClick={(e) => {
                  }}
                >
                  {subscribedService ? 'save' : 'subscribe'}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      {(isLoading || isSaveCardLoading) && <PageLoader />}
    </div>
  );
};

export default EditSubServiceTypeDialog;
